import {
  requestLoginUser,
  requestLogOutUser,
  requestCurrentUser,
  requestBuyPoint,
  requestPointAppend,
  requestConfirmNotice,
  requestPointEnd,
  requestUserDetail,
  requestChangeUserInformation,
  requestChangeUserPassword,
  requestConfirmUser,
  requestReissuePassword,
  requestReissuePasswordOneTime,
  requestChangeUserAddress,
  requestGoogleCreate,
  requestGoogleLogin,
  requestAppendUser,
  requestHasRegister,
  requestSetReferralCode,
  requestChangeLanguage,
  requestDeleteIsUserRegister,
  requestChangeCountry,
  requestBuyRank,
  requestDeleteCard,
  requestPointSavedCard,
  requestSavedCard,
} from '@/api/user';

const state = {
  loginUserResult: null,
  logOutUserResult: null,
  currentUser: null,
  buyPointResult: null,
  currentUserDetail: null,
  pointAppendResult: null,
  confirmNoticeResult: null,
  pointEndResult: null,
  changeUserInformationResult: null,
  changeUserPasswordResult: null,
  changeUserAddressResult: null,
  confirmUserResult: null,
  googleCreateResult: null,
  googleLoginResult: null,
  appendUserResult: null,
  reissuePasswordResult: null,
  reissuePasswordOneTimeResult: null,
  buyRankResult: null,
  isRegister: null,
  setReferralCodeResult: null,
  showMyPage: false,
  showLoginPage: false,
  changeCountryResult: null,
  changeLanguageResult: null,
  currentLanguage: 'ja',
  pointSavedCard: null,
  saveCard: null,
  deleteCard: null,
};

const getters = {
  loginUserResult: (state) => state.loginUserResult,
  logOutUserResult: (state) => state.logOutUserResult,
  currentUser: (state) => state.currentUser,
  buyPointResult: (state) => state.buyPointResult,
  currentUserDetail: (state) => state.currentUserDetail,
  pointAppendResult: (state) => state.pointAppendResult,
  pointEndResult: (state) => state.pointEndResult,
  confirmNoticeResult: (state) => state.confirmNoticeResult,
  changeUserInformationResult: (state) => state.changeUserInformationResult,
  changeUserPasswordResult: (state) => state.changeUserPasswordResult,
  changeUserAddressResult: (state) => state.changeUserAddressResult,
  confirmUserResult: (state) => state.confirmUserResult,
  googleLoginResult: (state) => state.googleLoginResult,
  googleCreateResult: (state) => state.googleCreateResult,
  appendUserResult: (state) => state.appendUserResult,
  reissuePasswordResult: (state) => state.reissuePasswordResult,
  reissuePasswordOneTimeResult: (state) => state.reissuePasswordOneTimeResult,
  buyRankResult: (state) => state.buyRankResult,
  isRegister: (state) => state.isRegister,
  setReferralCodeResult: (state) => state.setReferralCodeResult,
  showMyPage: (state) => state.showMyPage,
  showLoginPage: (state) => state.showLoginPage,
  changeCountryResult: (state) => state.changeCountryResult,
  changeLanguageResult: (state) => state.changeLanguageResult,
  currentLanguage: (state) => state.currentLanguage,
  pointSavedCard: (state) => state.pointSavedCard,
  saveCard: (state) => state.saveCard,
  deleteCard: (state) => state.deleteCard,
};

const actions = {
  async loginUser({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestLoginUser({ csrfToken, postParams });
    commit('setLoginUserResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearLoginUserResult({ commit }) {
    commit('setLoginUserResult', null);
  },
  async logOutUser({ commit, dispatch }) {
    dispatch('setIsLoading', true, { root: true });
    console.log('test');
    const result = await requestLogOutUser();
    commit('setLogOutUserResult', result.data);
    dispatch('setIsLoading', false, { root: true });
  },
  clearLogOutUserResult({ commit }) {
    commit('setLogOutUserResult', null);
  },
  async setCurrentUser({ commit }) {
    // await dispatch('setIsLoading', true, { root: true });
    const result = await requestCurrentUser();
    commit('setCurrentUser', result.data);
    // languageというプロパティがあれば、セットする
    if (result.data.language) {
      commit('setCurrentLanguage', result.data.language);
    }
    // await dispatch('setIsLoading', false, { root: true });
  },
  async buyPoint({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestBuyPoint({ csrfToken, postParams });
    commit('setBuyPointResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearBuyPointResult({ commit }) {
    commit('setBuyPointResult', null);
  },
  async pointAppend({ commit, dispatch, rootGetters }, { postParams }) {
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestPointAppend({ csrfToken, postParams });
    commit('setPointAppendResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  async setPointEndResult({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestPointEnd();
    commit('setPointEndResult', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setConfirmNotice({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestConfirmNotice();
    commit('setConfirmNotice', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setCurrentUserDetail({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestUserDetail();
    commit('setCurrentUserDetail', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async changeUserInformation({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestChangeUserInformation({ csrfToken, postParams });
    commit('setChangeUserInformationResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  async changeUserAddress({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestChangeUserAddress({ csrfToken, postParams });
    commit('setChangeUserAddressResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearChangeUserInformationResult({ commit }) {
    commit('setChangeUserInformationResult', null);
  },
  async changeUserPassword({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestChangeUserPassword({ csrfToken, postParams });
    commit('setChangeUserPasswordResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearChangeUserPasswordResult({ commit }) {
    commit('setChangeUserPasswordResult', null);
  },
  async confirmUser({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestConfirmUser({ csrfToken, postParams });
    commit('setConfirmUserResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  async googleLogin({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestGoogleLogin({ csrfToken, postParams });
    commit('setGoogleLoginResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  async googleCreate({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestGoogleCreate({ csrfToken, postParams });
    commit('setGoogleCreateResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearConfirmUserResult({ commit }) {
    commit('setConfirmUserResult', null);
  },
  async appendUser({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestAppendUser({ csrfToken, postParams });
    commit('setAppendUserResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearAppendUserResult({ commit }) {
    commit('setAppendUserResult', null);
  },
  async reissuePassword({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestReissuePassword({ csrfToken, postParams });
    commit('setReissuePasswordResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  async reissuePasswordOneTime({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestReissuePasswordOneTime({ csrfToken, postParams });
    commit('setReissuePasswordOneTimeResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearReissuePasswordResult({ commit }) {
    commit('setReissuePasswordResult', null);
    commit('setReissuePasswordOneTimeResult', null);
  },
  async buyRank({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestBuyRank({ csrfToken, postParams });
    commit('setBuyRankResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearBuyRankResult({ commit }) {
    commit('setBuyRankResult', null);
  },
  async hasRegister({ commit, dispatch }) {
    dispatch('setIsLoading', true, { root: true });
    const result = await requestHasRegister();
    commit('setHasRegister', result.data);
    dispatch('setIsLoading', false, { root: true });
  },
  clearHasRegister({ commit }) {
    commit('setHasRegister', null);
  },
  async setReferralCode({ commit, dispatch, rootGetters }, { postParams }) {
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestSetReferralCode({ csrfToken, postParams });
    commit('setSetReferralCodeResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearSetReferralCodeResult({ commit }) {
    commit('setSetReferralCodeResult', null);
  },
  async deleteIsUserRegister({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    await requestDeleteIsUserRegister();
    commit('setHasRegister', null);
    await dispatch('setIsLoading', false, { root: true });
  },
  setShowMyPage({ commit }, showMyPage) {
    console.log('showMyPage', showMyPage);
    commit('setShowMyPage', showMyPage);
  },
  setShowLoginPage({ commit }, showLoginPage) {
    commit('setShowLoginPage', showLoginPage);
  },
  async changeCountry({ commit, dispatch, rootGetters }, { postParams }) {
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestChangeCountry({ csrfToken, postParams });
    commit('setChangeCountryResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  async changeLanguage({ commit, dispatch, rootGetters }, { postParams }) {
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestChangeLanguage({ csrfToken, postParams });
    commit('setChangeLanguageResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearChangeCountryResult({ commit }) {
    commit('setChangeCountryResult', null);
  },
  setCurrentLanguage({ commit }, currentLanguage) {
    commit('setCurrentLanguage', currentLanguage);
  },
  async setPointSavedCard({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestPointSavedCard();
    commit('setPointSavedCard', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async saveCard({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestSavedCard({ csrfToken, postParams });
    commit('setSaveCard', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  async deleteCard({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestDeleteCard({ csrfToken, postParams });
    commit('setDeleteCard', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  setLoginUserResult(state, loginUserResult) {
    state.loginUserResult = loginUserResult;
  },
  setLogOutUserResult(state, logOutUserResult) {
    state.logOutUserResult = logOutUserResult;
  },
  setCurrentUser(state, currentUser) {
    state.currentUser = currentUser;
  },
  setBuyPointResult(state, buyPointResult) {
    state.buyPointResult = buyPointResult;
  },
  setPointAppendResult(state, pointAppendResult) {
    state.pointAppendResult = pointAppendResult;
  },
  setPointEndResult(state, pointEndResult) {
    state.pointEndResult = pointEndResult;
  },
  setConfirmNotice(state, confirmNotice) {
    state.confirmNotice = confirmNotice;
  },
  setCurrentUserDetail(state, currentUserDetail) {
    state.currentUserDetail = currentUserDetail.detail;
  },
  setChangeUserInformationResult(state, changeUserInformationResult) {
    state.changeUserInformationResult = changeUserInformationResult;
  },
  setChangeUserPasswordResult(state, changeUserPasswordResult) {
    state.changeUserPasswordResult = changeUserPasswordResult;
  },
  setConfirmUserResult(state, confirmUserResult) {
    state.confirmUserResult = confirmUserResult;
  },
  setChangeUserAddressResult(state, changeUserAddressResult) {
    state.changeUserAddressResult = changeUserAddressResult;
  },
  setGoogleLoginResult(state, googleLoginResult) {
    state.googleLoginResult = googleLoginResult;
  },
  setGoogleCreateResult(state, googleCreateResult) {
    state.googleCreateResult = googleCreateResult;
  },
  setAppendUserResult(state, appendUserResult) {
    state.appendUserResult = appendUserResult;
  },
  setReissuePasswordResult(state, reissuePasswordResult) {
    state.reissuePasswordResult = reissuePasswordResult;
  },
  setReissuePasswordOneTimeResult(state, reissuePasswordResult) {
    state.reissuePasswordOneTimeResult = reissuePasswordResult;
  },
  setBuyRankResult(state, buyRankResult) {
    state.buyRankResult = buyRankResult;
  },
  setHasRegister(state, isRegister) {
    state.isRegister = isRegister;
  },
  setSetReferralCodeResult(state, setReferralCodeResult) {
    state.setReferralCodeResult = setReferralCodeResult;
  },
  setShowMyPage(state, showMyPage) {
    state.showMyPage = showMyPage;
  },
  setShowLoginPage(state, showLoginPage) {
    state.showLoginPage = showLoginPage;
  },
  setChangeCountryResult(state, changeCountryResult) {
    state.changeCountryResult = changeCountryResult;
  },
  setChangeLanguageResult(state, changeLanguageResult) {
    state.changeLanguageResult = changeLanguageResult;
  },
  setCurrentLanguage(state, currentLanguage) {
    state.currentLanguage = currentLanguage;
  },
  setPointSavedCard(state, pointSavedCard) {
    state.pointSavedCard = pointSavedCard;
  },
  setSaveCard(state, saveCard) {
    state.saveCard = saveCard;
  },
  setDeleteCard(state, deleteCard) {
    state.deleteCard = deleteCard;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
